import './style.css'
import ReactDOM from 'react-dom/client'
import Experience from './Experience.jsx'
import UI from './UI.jsx'
import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react'
import { Analytics } from "@vercel/analytics/react"
import Wobble from './Wobble.jsx'
import { DSLloader } from './dslLoader.tsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
   <>  
    
    <Suspense fallback={null}> 
        <Canvas
            className="r3f"
            shadows
            dpr={[1.5,1.5]}
            camera={{ 
                position: [ 4, 3, 4 ], 
                fov: 45,
                }}
        >
           
                <Experience />
                

        <Analytics/>
        
        </Canvas>
        </Suspense> 
        <DSLloader />
        <Wobble />
        <UI />  
        
         
        
        


    
    </>
)


